<template>
  <v-dialog
    v-if="localShowDialog"
    v-model="localShowDialog"
    :width="600"
    @click:outside="$emit('closed')"
  >
    <v-card tile>
      <v-app-bar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ item.name || '' }}</v-toolbar-title>
        <v-spacer />

        <v-toolbar-items>
          <v-btn
            dark
            icon
            @click.native="$emit('closed')"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-app-bar>
      <v-card-text class="pt-4">
        <v-alert
          class="d-block text-center text-h6"
          color="orange"
          text

        >
          <v-icon
            class="mr-2"
            color="orange"
          >fal fa-exclamation-triangle</v-icon>
          {{ $t('Does this product contain a tax stamp?') }}
        </v-alert>
        <v-row
          class="pa-2"
          wrap
        >
          <v-col
            class="pa-0 pl-1 pr-1"
            cols="6"
          >
            <v-btn
              :loading="$wait.is(`${item.id} adding to cart`)"
              block
              color="green"
              depressed
              x-large
              dark
              @click="$emit('item-selected', true)"
            >
              <v-icon
                dark
                left
                size="20px"
              >fal fa-check</v-icon> {{ $t('Yes') }}
            </v-btn>
          </v-col>
          <v-col
            class="pa-0 pl-1 pr-1"
            cols="6"
          >
            <v-btn
              :loading="$wait.is(`${item.id} adding to cart`)"
              block
              color="red"
              x-large
              dark
              @click="$emit('item-selected', false)"
            >
              <v-icon
                left
                dark
                size="20px"
              >fal fa-times</v-icon> {{ $t('No') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SelectTaxStampDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    localShowDialog: this.showDialog
  }),
  watch: {
    showDialog: {
      handler (newVal) {
        this.localShowDialog = newVal
      },
      immediate: true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/SelectTaxStampDialog.vue